import React from "react";
import Heading from "../../common/Heading";
import MySkillItem from "./MySkillItem";
import { skillSection } from "../../data";

import {
  Container,
  MySkillBox,
  SoftwareSkillContainer,
} from "./skills_elements";
import SoftwareSkill from "./SoftwareSkill";

const Skills = () => {
  return (
    <Container id="skills">
      <Heading heading="What i can do" subheading="" />

      <SoftwareSkillContainer>
        {skillSection.softwareSkills.map((softSkill, i) => {
          return (
            <SoftwareSkill
              key={i}
              icon={softSkill.icon}
              title={softSkill.title}
              experience={softSkill.experience}
            />
          );
        })}
      </SoftwareSkillContainer>
      {/* <Fade right cascade duration={1000}> */}
      <MySkillBox>
        {skillSection.skillDetails.map((skill, i) => {
          return (
            <MySkillItem
              key={i}
              index={i}
              icon={skill.icon}
              heading={skill.title}
              subheading={skill.description}
            />
          );
        })}
      </MySkillBox>
      {/* </Fade> */}
    </Container>
  );
};

export default Skills;
